// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 209) return "static/chunks/209-5eaad2b147ba5911.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"b25988f8e3fe2437","340":"efb5a6acbed5afb8","367":"20d22f6a5b5ee667","639":"e7b660adfa99260e","677":"a73ab561e3dcc446","748":"717f5d6d12814f12"}[chunkId] + ".js";
};